{
  "raw": "1.0.10-demo",
  "hash": "1.0.10-demo",
  "distance": 0,
  "tag": "1.0.10-demo",
  "semver": "1.0.10-demo",
  "semverString": "1.0.10-demo",
  "suffix": ""
}